<template>
  <div class="main" v-title data-title="试剂采购库存管理系统">
    <el-image
        style="width: 100%;height: 100%"
        :src="currentImg.url"
        fit="fill"></el-image>
    <div class="top-button-container">
      <el-button class="button" round @click="exit" v-if="!isFirstGuide">退出</el-button>
    </div>
    <div class="button-container">

      <el-button class="button" round @click="previousStep" v-if="currentImg.index>0">上一步</el-button>
      <el-button class="button"  type="primary" round @click="nextStep" v-if="currentImg.index<guideImg.length-1">下一步</el-button>
      <el-button class="button"  type="primary" round @click="finish" v-if="currentImg.index==guideImg.length-1">完 成</el-button>
    </div>
  </div>

</template>

<script>
export default {
  name: "Guide",
  data(){
    return {
      currentImg:{index:0,url:'',baseUrl:'',pictureName:''},
      guideImg:[
         //  "http://admin.lawkeychem.com/files/pageGuide/guide1.png",
         //
         //  "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
         //
         // "http://admin.lawkeychem.com/files/pageGuide/guide1.png",

      ],
      isFirstGuide:false,
    }
  },
  created() {
    this.getGuidePage();

  },
  methods:{
    exit(){
      this.removeOpenAttr();
      if(this.isFirstGuide == false){
        this.$router.go(-1)
      }
    },
    removeOpenAttr(){
      localStorage.removeItem("open")
    },
    async getGuidePage(){
      this.$apiFetch.get("lockerUser/guideUser").then((res) => {
        console.log(res.data)
        const open = localStorage.getItem("open");
        console.log("first:",res.data.firstGuide,"open :",open)
        if(res.data.firstGuide || open == "true"){
          this.isFirstGuide = res.data.firstGuide
          this.guideImg = null,
          this.guideImg = res.data.pictureNames
          this.currentImg.baseUrl = res.data.pictureBaseUrl
          this.currentImg.url = this.currentImg.baseUrl + this.guideImg[0]
          this.currentImg.index = 0
          console.log(this.currentImg.url)
        }else{
          this.$router.push("/home")
        }
      }).catch(err=>{
        this.$router.push("/home")
      });
    },
    previousStep(){
      let index = this.currentImg.index
      if(index-1>=0){
        this.currentImg.index -=1
        this.currentImg.url =  this.currentImg.baseUrl + this.guideImg[this.currentImg.index]
      }
    },
    nextStep(){
      let index = this.currentImg.index
      if(index+1<this.guideImg.length){
        this.currentImg.index +=1
        this.currentImg.url =  this.currentImg.baseUrl + this.guideImg[this.currentImg.index]
      }
    },
    finish(){
      this.removeOpenAttr();
      if(this.isFirstGuide){
        this.$router.push({ path: "home" });
      }else{
        this.$router.go(-1);
      }
    },
  }
}
</script>

<style scoped>
.button-container {
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
}
.top-button-container {
  position: fixed;
  top: 25px;
  left: 60px;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
}

.button {
  margin: 0 10px;
}
</style>